<template>
    <v-app id="inspire">
    <v-content>
      <v-container grid-list-xl>
        <!-- <v-layout align-center justify-center>
          <v-flex xs12 sm10 md10>
            <v-alert v-if="user.data.city_accommodation && !user.data.accommodated" :value="true" type="info">
              Reminder: You haven't assigned the free accommodation to any of your team members.
            </v-alert>
          </v-flex>
        </v-layout> -->
        <v-layout align-center justify-center>
          <v-flex xs12 sm10 md10>
            <v-card class="elevation-12">
              <v-toolbar color="red" dark>
                <v-toolbar-title>Project Information</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-list two-line>
                  <v-list-tile>
                    <v-list-tile-avatar>
                      <v-icon>fa fa-edit</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title><b>Project Name</b></v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ this.user.data.project.name }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-avatar>
                      <v-icon>fa fa-map-pin</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title><b>City</b></v-list-tile-title>
                      <v-list-tile-sub-title>{{ affiliation.city }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                 <!--  <v-list-tile>
                    <v-list-tile-avatar>
                      <v-icon> fa fa-codepen</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title><b>Width</b></v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ this.user.data.project.spec_width }} m
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-content>
                      <v-list-tile-title><b>Length</b></v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ this.user.data.project.spec_length }} m
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-content>
                      <v-list-tile-title><b>Height</b></v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ this.user.data.project.spec_height }} m
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-content>
                      <v-list-tile-title><b>Weight</b></v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ this.user.data.project.spec_weight }} kg
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile> -->

                  <v-list-tile>
                    <v-list-tile-avatar>
                      <v-icon>fa fa-th-list</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title><b>Competition</b></v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ competition.name }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-avatar>
                      <v-icon>fa fa-th-list</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title><b>Trend</b></v-list-tile-title>
                      <v-list-tile-sub-title>{{ competition.category }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile v-if="competition.sub_category">
                    <v-list-tile-avatar>
                      <v-icon>fa fa-th-list</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title><b>Sub Category</b></v-list-tile-title>
                      <v-list-tile-sub-title>{{ competition.sub_category }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile v-if="this.user.data.affiliation_type == 'university'">
                    <v-list-tile-avatar>
                      <v-icon>fa fa-graduation-cap</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title><b>University</b></v-list-tile-title>
                      <v-list-tile-sub-title>{{ affiliation.name }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile v-if="this.user.data.affiliation_type == 'university'">
                    <v-list-tile-avatar>
                      <v-icon>fa fa-graduation-cap</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title><b>College</b></v-list-tile-title>
                      <v-list-tile-sub-title>{{ college.name }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile v-if="this.user.data.affiliation_type == 'university' && college.department">
                    <v-list-tile-avatar>
                      <v-icon>fa fa-graduation-cap</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title><b>Department</b></v-list-tile-title>
                      <v-list-tile-sub-title>{{ college.department }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>


                  <v-list-tile v-if="this.user.data.affiliation_type == 'school'">
                    <v-list-tile-avatar>
                      <v-icon>fa fa-graduation-cap</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title><b>School</b></v-list-tile-title>
                      <v-list-tile-sub-title>{{ affiliation.name }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container grid-list-xl>
        <v-layout>
          <v-flex xs12 sm10 md10 offset-sm1>
            <v-card>
              <v-toolbar color="red" dark>
                <v-toolbar-title>Members</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon>group</v-icon>
              </v-toolbar>
              <v-list two-line>
                <template v-for="member in this.user.data.members">
                  <v-list-tile avatar :key="member.mail">
                    <v-list-tile-avatar>
                      <v-icon> fa fa-{{ member.gender }}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{member.name_en}} &mdash; {{member.name_ar}} </v-list-tile-title>
                      <v-list-tile-sub-title>
                        <v-icon>email</v-icon> {{member.email}} &mdash; 
                        <v-icon>phone</v-icon>{{member.phone}}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-icon v-if="member.has_accommodation"> fa fa-bed</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                </template>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>


      <v-container grid-list-xl>
        <v-layout>
          <v-flex xs12 sm10 md10 offset-sm1>
            <v-card>
              <v-toolbar color="red" dark>
                <v-toolbar-title>Supervisor</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon>grade</v-icon>
              </v-toolbar>
              <v-list two-line>
                <template v-for="supervisor in this.user.data.supervisor">
                  <v-list-tile avatar :key="supervisor.mail">
                    <v-list-tile-avatar>
                      <v-icon> fa fa-{{ supervisor.gender }}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{supervisor.name_en}} &mdash; {{supervisor.name_ar}} </v-list-tile-title>
                      <v-list-tile-sub-title>
                        <v-icon>email</v-icon> {{supervisor.email}} &mdash; 
                        <v-icon>phone</v-icon>{{supervisor.phone}}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container grid-list-xl>
        <v-layout>
          <v-flex xs12 sm10 md10 offset-sm1>
            <v-card>
              <v-toolbar color="red" dark>
                <v-toolbar-title>Project Details</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon>assignment</v-icon>
              </v-toolbar>
              <v-list three-line>
                <template v-for="answer in this.user.data.answers">
                  <v-list-tile avatar :key="answer.question_id">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ question_name(answer.question_id) }}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ answer.answer }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- <v-container grid-list-xl>
        <v-layout>
          <v-flex xs12 sm10 md10 offset-sm1>
            <v-card>
              <v-toolbar color="orange" dark>
                <v-toolbar-title>Items</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-title>Total Price: {{ this.user.data.total_price }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon>list</v-icon>
              </v-toolbar>
              <v-data-table :headers="headers" :items="user.data.logistics" hide-actions class="elevation-1">
                <template slot="items" slot-scope="props">
                  <td :key="logistics_hash">{{ item_name(props.item.item_id) }}</td>
                  <td class="text-xs-center">{{ props.item.quantity }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container> -->

      <v-container grid-list-xl v-if="!submitting">
        <v-layout>
          <v-flex xs12 sm10 md10 offset-sm1>
            <v-card-actions>
              <v-btn color="primary" left @click.prevent="rollBack">Previous</v-btn>
              <v-spacer></v-spacer>                
              <v-btn color="success" right @click.prevent="proceed">Submit</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-content v-if="submitting">
      <v-container grid-list-xl>
        <v-layout align-center justify-center>
          <v-flex xs1 sm1 md1>
            <v-progress-circular :size="50" indeterminate color="amber darken-4"></v-progress-circular>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-center>
          <p class="title orange--text text--darken-4">Submitting your data, please wait ...</p>
        </v-layout>
      </v-container>
    </v-content>
  </v-app> 
</template>
<script>
    export default {
        props: ['user', 'competitions', 'questions', 'cities', 'colleges', 'items', 'submitting'],
        computed: {
          competition() {
            let competition = this.competitions.find(competition => competition.id == this.user.data.competition_id);
            let category = competition.categories.find(category => category.id == this.user.data.category_id);
            let sub_category = category.sub_categories.find(sub_category => sub_category.id == this.user.data.sub_category_id)
            let sub_category_name = false
            if (sub_category) {
              sub_category_name = sub_category.name
            }
            return {
              name: competition.name,
              category: category.name,
              sub_category: sub_category_name
            }
          },
          affiliation() {
            let city = this.cities.find(city => city.id == this.user.data.city_id);
            if (this.user.data.affiliation_type == 'university') {
              let university = city.universities.find(university => university.id == this.user.data.university_id);
              return {
                name: university.name_en,
                city: city.name_en,
              }
            } else {
              return {
                name: this.user.data.school_name,
                city: city.name_en,
              }
            }
          },
          college() {
            let college = this.colleges.find(college => college.id == this.user.data.college_id);
            let department = college.departments.find(department => department.id == this.user.data.department_id);
            let department_name = false
            if (department) {
              department_name = department.name
            }
            return {
              name: college.name_en,
              department: department_name,
            }
          },
          logistics_hash() {
            let items = []
            for (let key in this.user.data.logistics ) {
              items.push(this.user.data.logistics[key].quantity);
            }
            return items.join('')
          }
        },
        data() {
          return {
            headers: [
              {text: 'Item Name', align: 'left', value: 'item_id'},
              {text: 'Quantity', align: 'center', value: 'quantity'}
            ]
          }
        },
        methods: {
          question_name(id) {
            let question = this.questions.find(question => question.id == id);
            return question.question;
          },
          item_name(id) {
            let item = this.items.find(item => item.id == id);
            return item.name;
          },
          proceed (){
            // this.$noty.info('Submitting your data, please wait ...');
            this.$emit('completed',this.user);
          },
          rollBack(){
             this.$emit('rollback',this.user)
          }
        }
    };
</script>
<style>
    
</style>


// WEBPACK FOOTER //
// src/components/Registeration/Submit.vue